import React from 'react';
import dayjs from 'op-utils/dayjs';
import { Badge } from 'shared-components/components';
import { CardTitle, CardBody, CardBodyGroup, BubbleTitle, CardText } from './styles';
import CONSTANTS from './constants';
import { Typography, useTheme } from '@mui/material';
import { CurrentAppConfig } from 'op-pages/RO/Careplan/AppConfig';
const { STATUS, NOTES, ASSIGNED, NO_ALERTS } = CONSTANTS;

const AlertsCard = ({ name, alerts }: { name: string; alerts: any }): JSX.Element => {
  const theme = useTheme();
  return (
    <div data-testid="alertsCard">
      <CardTitle>
        {name}{' '}
        {alerts?.length > 0 && (
          <Badge $bgColor={theme.palette.error.main} data-testid="alertsBadge">
            {alerts?.length}
          </Badge>
        )}
      </CardTitle>
      <CardBody>
        {alerts?.length > 0 ? (
          alerts.map((alert: any, index: number) => (
            <CardBodyGroup key={`${alerts.name}-${alerts.index}`}>
              <Typography variant="body2">
                {index + 1}. {alert.name}
              </Typography>
              <Typography variant="body2">
                {STATUS}: {alert.status} | {ASSIGNED}:{' '}
                {alert.assigned &&
                  dayjs.utc(alert.assigned).format(CurrentAppConfig.PatientCard.defaultAlternateDateFormat)}
              </Typography>
              <Typography variant="body2">
                {NOTES}: {alert.comment}
              </Typography>
            </CardBodyGroup>
          ))
        ) : (
          <CardBodyGroup>{NO_ALERTS}</CardBodyGroup>
        )}
      </CardBody>
    </div>
  );
};

export default AlertsCard;
